/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  func-names,
  import/no-extraneous-dependencies
*/
import 'intl';
import '../../scss/style.scss';
import 'css/ionicon/css/ionicons.min.css';
import fastclick from 'fastclick';
import WebFont from 'webfontloader';

import '../common/utils/log-uncaught-promises';
import Application from './application';
import config from '../common/config';
import logger from '../common/logger';
import '../common/logger/track-logger';
import configureRaven from '../common/utils/sentry';

// Load typekit fonts
try {
  Typekit.load();
  window.WebFont = WebFont;
} catch (_e) {
  // Fail silently
}


logger.track('entry.didLoad');

const app = Application.create(config);

window.onload = function () {

  // Adding Sentry Raven for error logging
  configureRaven({});

  // shims here
  fastclick.attach(document.body);

  app.setProperties(Object.assign({
    element: document.getElementById('signer-mobile-application'),
  }, window.config));

  app.initialize();
};

// make the app accessible from this console window
// IMPORTANT: do NOT access this global variable anywhere in the application. It's
// only intended to be used within the console window.
window.app = app;
